<template>
  <div class="shimmer-container">
    <div class="shimmer"></div>
  </div>
</template>

<script>
export default {
  name: 'CustomPlayerShimmer',
};
</script>

<style scoped>
  .shimmer-container {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .shimmer {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #eee 25%, #ddd 50%, #eee 75%);
    background-size: 200% 100%;
    animation: shimmer-animation 1.5s infinite linear;
  }

    @keyframes shimmer-animation {
        0% {
        background-position: 0 0;
        }
        100% {
        background-position: -200% 0;
        }
    }
</style>
